import { render, staticRenderFns } from "./Avtar.vue?vue&type=template&id=a444bfc0"
import script from "./Avtar.vue?vue&type=script&lang=js"
export * from "./Avtar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports